<template>
  <button
    @click="event => $emit('click', event)"
    :style="styles"
    :class="_class">
    <slot/>
  </button>
</template>

<script>
export default {
  name: 't-button',
  props: {
    backgroundColor: String,
    color: String,
    raised: Boolean,
    rounded: Boolean,
    size: {
      type: String,
      default: 'md',
      validator: value => {
        return ['sm', 'md', 'lg'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    styles () {
      return {
        '--btn-background-color': this.backgroundColor || 'var(--primary)',
        '--btn-color': this.color || 'var(--on-primary)'
      }
    },
    _class () {
      const c = ['t-button']
      this.raised && c.push('raised')
      this.rounded && c.push('rounded')
      c.push(this.size)
      return c.join(' ')
    }
  }
}
</script>

<style scoped lang="scss">
.t-button {
  background-color: var(--btn-background-color);
  color: var(--btn-color);
  transition: background-color 75ms linear;
  border: none;
  width: auto;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
  margin: 5px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    background-color: var(--btn-color);
    opacity: 0;
    inset: 0;
    transition: opacity 150ms ease;
  }
  &:hover::after {
    opacity: 0.08;
  }
  &.raised {
    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    transition: box-shadow 150ms ease;
    &:hover {
      box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%);
    }
  }
  &.sm {
    font-size: 5px;
    padding: 5px 10px;
    line-height: 1.6;
  }
  &.md {
    padding: 10px 22px;
    font-size: 13px;
    line-height: 1.58;
  }
  &.lg {
    padding: 10px 22px;
    font-size: 16px;
    line-height: 1.58;
    &.rounded {
      border-radius: 23px;
    }
  }
}
</style>
